import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className='footer container-link-mentions text-center'>
      <Link className='link-mentions' to="/mentions-legales">Mentions légales</Link>
    </footer>
  );
}

export default Footer;
